import { Numberu64, Socean } from "@soceanfi/stake-pool-sdk";
import type { Connection, Signer, Transaction } from "@solana/web3.js";
import { toLamports } from "@stepfinance/common";
import type { Dispatch, SetStateAction } from "react";

import { confirmOptions } from "../../constants/transaction";
import type { MultiTxnNotificationStrings } from "../../contexts/language/languageTypes";
import type { ConnectedWallet } from "../../hooks/wallet/useConnectedWallet";
import { SCN_MINT, STEP_SCNSOL_REFERRAL_ACCOUNT } from "../../models/socean";
import { sendAllTransactions } from "../../utils/transactions";
import { formatStringWithPlaceholders } from "../../utils/utils";
import { notifyStakeSuccess } from "../stakeNotifications";

export const soceanStake = async (
  wallet: ConnectedWallet,
  connection: Connection,
  amount: number,
  expectedScSOLAmount: number,
  onTransactionComplete: Dispatch<SetStateAction<boolean>>,
  notificationStrings: MultiTxnNotificationStrings,
) => {
  const socean = new Socean("mainnet-beta", connection);
  const amountToStake = new Numberu64(toLamports(amount, 9));

  const transactionSeq = await socean.depositSolTransactions(
    wallet.publicKey,
    amountToStake,
    STEP_SCNSOL_REFERRAL_ACCOUNT,
  );

  const transactions: Transaction[] = [];
  const signers: Signer[][] = [];

  for (const tseq of transactionSeq) {
    for (const t of tseq) {
      transactions.push(t.tx);
      signers.push(t.signers);
    }
  }

  return sendAllTransactions(
    connection,
    wallet,
    transactions,
    signers,
    {
      txnPendingMessage: formatStringWithPlaceholders(
        notificationStrings.youAreDoingAction.message,
        notificationStrings.youAreDoingAction.staked,
        "SOL",
      ),
      txnSuccessMessage: formatStringWithPlaceholders(
        notificationStrings.youDidAction.message,
        notificationStrings.youDidAction.staked,
        "SOL",
      ),
      onAllTransactionsConfirmed: () => {
        notifyStakeSuccess(amount, expectedScSOLAmount, SCN_MINT);
        onTransactionComplete(true);
      },
    },
    confirmOptions,
    notificationStrings,
  );
};
